import React from 'react';
import styles from './AssesmentAnalysis.module.css';
import testmonial1 from '../../../Images/testmonial1.jpg';
import testmonial2 from '../../../Images/testmonial2.jpg';
import testimonial3 from '../../../Images/testimonial3.jpg';
import fauto from '../../../Images/fauto.png';
import fskill from '../../../Images/fskill.png';
import fpredict from '../../../Images/fpredict.png';
import fvisual from '../../../Images/fvisual.png';
import fcustomizable from '../../../Images/fcustomizable.png';
import techit from '../../../Images/techit.png'
import corporate from '../../../Images/corporate.png';
import healthcarePharma from '../../../Images/healthcarePharma.png';
import Education from '../../../Images/Education.png';
import time from "../../../Images/time.png";
// import Insights from "../../image/insights.png";
// import Quality from "../../image/quality.png";
// import Integration from "../../image/integration.png";

import insights from '../../../Images/insights-rounded.png';
import quality from '../../../Images/high-quality-outline-rounded.png';
import integration from '../../../Images/integration-instructions.png';

const features = [
  { image: fauto, label: "Automated Scoring", desc: "AI evaluates test and interviews instantly." },
  { image: fskill, label: "Skill Gap Analysis", desc: "Identify strengths and weaknesses of candidates." },
  { image: fpredict, label: "Predictive Hiring Insights", desc: "Recommend top candidates based on performance." },
  { image: fvisual, label: "Visual Reports", desc: "Graphs and dashboards for performance comparison." },
  { image: fcustomizable, label: "Customizable Assessment Metrics", desc: "Tailor  evaluation to your role requirements." },
];

const cards = [
  { image: time, title: "Save Time", desc: "Automate evaluation of coding tests, aptitude tests, and interviews" },
  { image: insights, title: "Objective Insights", desc: "Remove human bias and get data-driven recommendations" },
  { image: quality, title: "Improve Hiring Quality", desc: "Identify top talent quickly with accurate scoring." },
  { image: integration, title: "Seamless Integration", desc: "Works with your existing ATS and HR tools." },
];
const benefits = [
  "Faster Recruitment Decisions",
  "Consistent Evaluation",
  "Data-Driven Insights",
  "Improved Candidate Experience",
  "Scalability for Bulk Assessments"
];

const multimodal = [
  { title: "Aptitude & Technical Tests", desc: "Coding, logic, reasoning" },
  { title: "Behavioral & Soft Skills", desc: "Analyze speech, tone, and communication" },
  { title: "Video & Audio Analysis", desc: "Evaluate recorded interviews automatically" },
  { title: "Written Assessments", desc: "Automatic scoring and ranking of essays or responses" }
];


const applications = [
  { image: techit, label: "Tech & IT", desc: "Automated coding test evaluations and technical interview." },
  { image: corporate, label: "Corporate & Finance", desc: "Standardized assessment of analytical and behavioral skills." },
  { image: healthcarePharma, label: "Healthcare & Pharma", desc: "Evaluate practical knowledge and certifications." },
  { image: Education, label: "Education & Training", desc: "Analyze teaching and assessment capabilities." }
];


const testimonials = [
  { name: 'Tech Recruiter', quote: "Toxbox AI provides accurate assessments, reducing hiring time drastically.", image: testmonial1 },
  { name: 'HR Manager', quote: "Candidate evaluation is now fair, fast, and data-driven.", image: testmonial2 },
  { name: 'Enterprise Client', quote: "We quickly identify top performers across multiple rounds.", image: testimonial3 },
];

export default function AssesmentAnalysis() {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <nav className={styles.nav}>
          <span className={styles.logo}>🦾</span>
          <ul className={styles.navMenu}>
            <li>Products</li>
            <li>About Us</li>
          </ul>
          <div className={styles.headerButtons}>
            <button className={`${styles.demoButton} ${styles.headerButtons}`}>Book Demo</button>
            <button className={styles.signInButton}>Sign In</button>
          </div>
        </nav>
        <section className={styles.heroSection}>
          <h1>
            Smarter Candidate  <br /> Assessments, Analyze<br />
            Candidate Assessments <br /> Instantly with AI
          </h1>
          <p>Toxbox AI evaluates interviews and tests, providing deep insights to help you hire the right talent faster</p>
          <div className={styles.ctaButtons}>
            <button className={styles.buttonPrimary}>Get Started</button>
            <button className={styles.buttonSecondary}>Request a Demo</button>
          </div>
        </section>
      </header>

      <main>
        <main className={styles.mainContent}>
          <h2 className={styles.sectionTitle}>Why AI-Powered Assessment Analysis?</h2>
          <section className={styles.sectionWrapper}>
            {/* <h2 className={styles.sectionTitle}>Why AI-Powered Assessment Analysis?</h2> */}
            <div className={styles.cardGrid}>
              {cards.map((c) => (
                <div className={styles.aacard} key={c.title}>
                  <img src={c.image} alt={c.title} className={styles.aaImage} />
                  <h3>{c.title}</h3>
                  <p>{c.desc}</p>
                </div>
              ))}
            </div>
          </section>
        </main>


        <section className={styles.ksectionWrapper}>
          <h2 className={styles.ksectionTitle}>Key Features</h2>
          <div className={styles.kcardGrid}>
            {features.map(f => (
              <div className={styles.featureCard} key={f.label}>
                <img src={f.image} alt={f.label} className={styles.featureImage} />
                <h4>{f.label}</h4>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.hsectionWrapper}>
          <h2 className={styles.hsectionTitle}>How It Works</h2>
          <ol className={styles.howItWorksList}>
            <li><div className={styles.circle}><span className={styles.spanno}>1</span></div>Candidate completes assessments or interviews</li>
            <li><div className={styles.circle}><span className={styles.spanno}>2</span></div>AI evaluates responses based on predefined criteria</li>
            <li><div className={styles.circle}><span className={styles.spanno}>3</span></div>Insights and scores are generated instantly</li>
            {/* <>vertical line here </> */}
            <li><div className={styles.circle}><span className={styles.spanno}>4</span></div>Recruiters receive actionable recommendations</li>
            <li><div className={styles.circle}><span className={styles.spanno}>5</span></div>Top candidates are identified for next steps</li>
          </ol>
        </section>

        {/* /* <section className={styles.benefitMultimodalWrapper}>
          <div className={styles.benefits}>
            <h3>Benefits</h3>
            
            <ul>
              {benefits.map(b => <li key={b}>{b}</li>)}
            </ul>
             
          </div>
          <div className={styles.multimodal}>
            <h3>Multimodal Assessment Support</h3>
            <ul>
              {multimodal.map(m => <li key={m}>{m}</li>)}
            </ul>
          </div>
        </section> */ }
        <section className={styles.benefitMultimodalWrapper}>
          <div className={styles.benefits}>
            <h3>Benefits</h3>
            <ul>
              {benefits.map((b, index) => (
                <li key={index}>
                  <strong>{b}</strong>
                  <p>Reduce time-to-hire significantly.</p>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.multimodal}>
            <h3>Multimodal Assessment Support</h3>
            <ul>
              {multimodal.map((m, index) => (
                <li key={index} className={styles.multiCard}>
                  <strong>{m.title}</strong>
                  <p>{m.desc}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <div className={styles.insightsWrapper}>
          <section className={styles.insightsSection}>
            <h2 className={styles.insectionTitle}>AI Insights & Recommendations</h2>
            <button className={styles.grayButton}>Highlight top performers for each skill </button>
            <button className={styles.grayButton}>Suggest improvement areas for candidates</button>
            <button className={styles.grayButton}>Suggest improvement areas for candidates</button>
          </section>
          <div style={{
            width: "80%",
            height: "2px",
            background: "#fff",
            margin: "20px auto"
          }}></div>

          <section className={` ${styles.rescoreSection}`}>
            <h2 className={styles.insectionTitle}>Rescore & Review Flexibility</h2>
            <div className={styles.incardGrid}>
              <div className={styles.incard}>Recruiters can manually adjust scores if needed</div>
              <div className={styles.incard}>AI adapts learning from recruiter feedback</div>
              <div className={styles.incard}>Ensures accuracy and fairness in assessment</div>
            </div>
          </section>
        </div>



        <section className={styles.industrysectionWrapper}>
          <h2 className={styles.industrysectionTitle}>Industry Applications</h2>
          <div className={styles.appGrid}>
            {applications.map(app => (
              <div className={styles.appICard} key={app.label}>
                <img src={app.image} alt={app.label} className={styles.appimage} />
                <h4>{app.label}</h4>
                <p>{app.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.testimonialSection}>
          <h2 className={styles.sectionTitle}>Customer Testimonials</h2>
          <p>Trusted by HR Leaders & Recruiters Trusted by HR Leaders & Recruiters</p>
          <div className={styles.testimonialGrid}>
            {testimonials.map(t => (
              <div className={styles.testimonialCard} key={t.quote}>
                <div  > <img className={styles.testimonialimage} src={t.image} alt='imag ' /></div>
                <div><div className={styles.name}>{t.name}</div>
                  {t.role && <div className={styles.role}>{t.role}</div>}
                  <div className={styles.quote}>&ldquo;{t.quote}&rdquo;</div></div>

              </div>
            ))}
          </div>
        </section>

        <section className={styles.footerCTA}>
          <h2>Make Smarter Hiring Decisions with AI</h2>
          <p>Automate assessments, gain insights, and hire top talent faster with Toxbox AI</p>
          <div className={styles.ctaButtons}>
            <button className={styles.buttonPrimary}>Get Started</button>
            <button className={styles.buttonSecondary}>Request a Demo</button>
          </div>
        </section>

        <section className={styles.secureSection}>
          <h3 className={styles.sectionTitle}>Secure & Reliable Candidate Data Management</h3>
          <div className={styles.secureButtons}>
            <div className={styles.secButton}>GDPR-compliant assessment data storage</div>
            <div className={styles.secButton}>Secure dashboards and report generation</div>
            <div className={styles.secButton}>Trusted by enterprises globally</div>
          </div>
        </section>
      </main>
    </div>
  );
}


